import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useT } from '../i18n';

function Impressum() {
  const t = useT();
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#080a0e', color: '#e2e2e8', fontFamily: "var(--font-display)", padding: '48px 24px' }}>
      <div style={{ maxWidth: 680, margin: '0 auto' }}>

        {/* Back */}
        <button onClick={() => navigate(-1)} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontFamily: "'JetBrains Mono', monospace", fontSize: 11, letterSpacing: '0.12em', color: 'rgba(var(--brand-primary-rgb),0.65)', background: 'none', border: 'none', cursor: 'pointer', marginBottom: 48, padding: 0 }}
          onMouseEnter={e => e.currentTarget.style.color = 'var(--brand-primary)'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(var(--brand-primary-rgb),0.65)'}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square"><polyline points="15,18 9,12 15,6"/></svg>
          {t('impressum_back')}
        </button>

        <h1 style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, fontWeight: 700, letterSpacing: '0.2em', color: 'var(--brand-primary)', margin: '0 0 40px 0' }}>
          {t('impressum_title')}
        </h1>

        <section style={{ marginBottom: 32 }}>
          <p style={{ fontSize: 13, fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.06em', color: 'rgba(var(--brand-primary-rgb),0.4)', marginBottom: 8 }}>{t('impressum_tmg_label')}</p>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#c8d0d1' }}>
            Martin Schramm<br />
            Brückenstr. 14<br />
            53474 Ahrweiler<br />
            Deutschland
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <p style={{ fontSize: 13, fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.06em', color: 'rgba(var(--brand-primary-rgb),0.4)', marginBottom: 8 }}>{t('impressum_contact_label')}</p>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#c8d0d1' }}>
            E-Mail: <a href="mailto:martin@critroster.cc" style={{ color: 'var(--brand-primary)', textDecoration: 'none' }}>martin@critroster.cc</a>
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <p style={{ fontSize: 13, fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.06em', color: 'rgba(var(--brand-primary-rgb),0.4)', marginBottom: 8 }}>{t('impressum_responsible_label')}</p>
          <p style={{ fontSize: 15, lineHeight: 1.8, color: '#c8d0d1' }}>
            Martin Schramm<br />
            Brückenstr. 14<br />
            53474 Ahrweiler
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <p style={{ fontSize: 13, fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.06em', color: 'rgba(var(--brand-primary-rgb),0.4)', marginBottom: 8 }}>{t('impressum_liability_content_label')}</p>
          <p style={{ fontSize: 14, lineHeight: 1.8, color: 'rgba(185,202,203,0.7)' }}>
            {t('impressum_liability_content_text')}
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <p style={{ fontSize: 13, fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.06em', color: 'rgba(var(--brand-primary-rgb),0.4)', marginBottom: 8 }}>{t('impressum_liability_links_label')}</p>
          <p style={{ fontSize: 14, lineHeight: 1.8, color: 'rgba(185,202,203,0.7)' }}>
            {t('impressum_liability_links_text')}
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <p style={{ fontSize: 13, fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.06em', color: 'rgba(var(--brand-primary-rgb),0.4)', marginBottom: 8 }}>{t('impressum_copyright_label')}</p>
          <p style={{ fontSize: 14, lineHeight: 1.8, color: 'rgba(185,202,203,0.7)' }}>
            {t('impressum_copyright_text')}
          </p>
        </section>

        <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid rgba(var(--brand-primary-rgb),0.1)', fontFamily: "'JetBrains Mono', monospace", fontSize: 9, color: 'rgba(var(--brand-primary-rgb),0.25)', letterSpacing: '0.08em' }}>
          CRIT ROSTER — CRITROSTER.CC
        </div>

      </div>
    </div>
  );
}

export default Impressum;
